import { Body, Heading } from "@songtradr-one/components-frontend";
import { Flex } from "../flex/Flex.Parts";
import { EmptyStateProps, Wrapper } from "./EmptyState.Parts";

export const EmptyState = ({
  title,
  text,
  topPadding = true,
  children,
}: EmptyStateProps) => {
  return (
    <Wrapper $topPadding={topPadding}>
      <Flex $gap="1.5rem" $align="center" $direction="column">
        {title && <Heading variant="h2">{title}</Heading>}
        {text && <Body>{text}</Body>}
      </Flex>
      {children}
    </Wrapper>
  );
};
